import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const ProductDetailsSkeleton = () => {
    return (
        <div className="w-full h-96 flex flex-col justify-start gap-3 mb-3 xl:mb-5 bg-cards-bg">
            <Skeleton width={'100%'} className={'w-full h-96'}/>
        </div>
    );
};
